/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Fragment, ReactNode, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { queryClient } from '../../../main';
import {
    Menu,
    Dialog,
    Transition,
} from "@headlessui/react";
import { toast } from 'react-toastify';
import Input from '../../Shared/Input';
import { useFormik } from "formik";
import * as Yup from "yup";
import { AddDiscountToPackage } from '../../../api/Packages/AddDiscount';
import { DeletePackage } from '../../../api/Packages/DeletePackage';
import { Link } from 'react-router-dom';
const validationSchema = Yup.object({
    discountPrecentage: Yup.number().required("Discount Precentage is required"),
});


const PackageDropdown = ({ children, packageId, role }: { children?: ReactNode, packageId: string; role: string }) => {

    const { mutate: deletePackage } = useMutation({
        mutationFn: DeletePackage,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["packages"] });
            toast.success("Package deleted successfully");
        },
    });
    const [isOpen, setIsOpen] = useState(false);
    const { mutate } = useMutation({
        mutationFn: AddDiscountToPackage,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["packages"] });
            toast.success("Discount Added successfully");
            formik.resetForm();
            setIsOpen(false)
        },
        onError: () => {
            formik.setSubmitting(false);
        },
    });

    const formik = useFormik({
        initialValues: {
            discountPrecentage: "",
        },
        validationSchema,
        onSubmit: (values) => {
            if (packageId) {
                mutate({
                    id: packageId,
                    payload: {
                        ...values,
                        discountPrecentage: Number(values.discountPrecentage)
                    }
                });
            }
        },
    });


    return (
        <div className="relative ">
            <Menu as="div" className="relative inline-block">
                <div>
                    <Menu.Button className="inline-flex w-full justify-center  focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75">
                        {children}
                    </Menu.Button>
                </div>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Menu.Items className="absolute md:-top-40 md:right-0 right-5 mt-2 w-[221px] origin-top-right divide-y divide-gray-100 rounded-[7px] border-slate bg-white border border-opacity-20  backdrop-blur-[7.5px] bg-hayak_gray bg-opacity-80 text-left shadow-lg ring-1  -top-4 py-6 px-5 ring-black/5 focus:outline-none z-50 text-primary font-medium text-lg">
                        <div className=' flex flex-col gap-3'>
                            {role === 'admin' &&
                                <Menu.Item>
                                    <Link to={`edit-package/${packageId}`}>Edit Package</Link>
                                </Menu.Item>
                            }
                            <Menu.Item>
                                <button className='text-start' onClick={() => setIsOpen(true)}>Add Discount</button>
                            </Menu.Item>
                            {role === 'admin' &&
                                <Menu.Item>
                                    <button className='text-left text-red-700' onClick={() => deletePackage(packageId)}>Delete Package</button>
                                </Menu.Item>
                            }
                        </div>
                    </Menu.Items>
                </Transition>
            </Menu>
            <Transition enter="ease-out duration-300"
                enterFrom="opacity-0 transform-[scale(95%)]"
                enterTo="opacity-100 transform-[scale(100%)]"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 transform-[scale(100%)]"
                leaveTo="opacity-0 transform-[scale(95%)]"
                appear show={isOpen}>
                <Dialog
                    as="div"
                    className="relative z-10 focus:outline-none"
                    onClose={() => setIsOpen(false)}
                >
                    <div
                        className="fixed inset-0 z-10 w-screen overflow-y-auto bg-black/15">
                        <div className="flex min-h-full items-center justify-center p-4 ">
                            <form onSubmit={formik.handleSubmit} className="w-full max-w-md rounded-xl p-6 text-secondaryText bg-white transition-all duration-300 hover:border-primary border-black/30 shadow border relative z-[9999999999999]">
                                <h3
                                    className="text-base/7 font-medium text-center"
                                >
                                    Confirmation Message
                                </h3>
                                <p className="mt-2 text-sm/6 mb-2 text-center">
                                    How much do you want your discount to be
                                </p>
                                <Input
                                    value={formik.values.discountPrecentage}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={
                                        formik.touched.discountPrecentage && formik.errors.discountPrecentage
                                            ? formik.errors.discountPrecentage
                                            : ""
                                    }
                                    className="w-full"
                                    inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                                    name="discountPrecentage"
                                    placeholder=""
                                />

                                <div className="mt-4 flex justify-center ">
                                    <button
                                        className="gap-2 rounded-md bg-green-500 hover:bg-green-700 py-1.5 w-40 text-center text-sm/6 font-semibold  shadow-inner shadow-white/10 focus:outline-none duration-300 transition-all text-white "
                                    >
                                        Add Discount
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </Dialog>
            </Transition>

        </div>
    )
}

export default PackageDropdown